/*
 * @providesModule SKZAPIConstants
 */


const SKZAPIConstantsInstance = {
  SKZ_API_ERR_EMAIL_NOT_SET: 1700,
  SKZ_API_ERR_EMAIL_VERIFICATION_REQUIRED: 170,
  SKZ_API_ERR_WITHDRAWAL_ADDRESS_REQUIRED: 133,
  SKZ_API_BASE_PROD: 'skillz.com/',
  SKZ_API_BASE_STAGE: 'staging.skillz.com/',
  SKZ_API_BASE_SAND: 'sandbox.skillz.com/',
  SKZ_API_BASE_QA: 'qa.skillz.com/',
  SKZ_API_BASE_PROXY_TS: 'dev.skillz.com/',
  SKZ_SHOW_BRACKET_WARNING: '@@@FTUE@@@_BRACKET_JOIN_CANCELLATION',
  SKZ_HIDE_MUTE_CHAT_WARNING: 'MUTE_CHAT_WARNING_CONFIRMATION',
  // append roomName when called
  SKZ_HIDE_BLOCKED_MODAL: 'SKZ_HIDE_BLOCKED_MODAL.',
} as const;
export default SKZAPIConstantsInstance;
